import qs, { IParseOptions, IStringifyOptions, ParsedQs } from 'qs';

type QueryStringValue = string | boolean | ParsedQs | boolean[] | string[] | ParsedQs[] | null;

type DefaultQueryStringValue = Extract<QueryStringValue, string | boolean | null>;

type QueryStringKeyValue = { [key: string]: QueryStringValue };

type DefaultQueryStringKeyValue = { [key: string]: DefaultQueryStringValue };

const defaultParseOptions: IParseOptions = {
    allowDots: false,
    depth: 0,
    parseArrays: false,
    ignoreQueryPrefix: true,
    decoder: (string, defaultDecoder, charset, type) => {
        if (type === 'value')
            if (string === 'true')
                return true;
            else if (string === 'false')
                return false;
            else if (string === 'null' || !string)
                return null;

        return defaultDecoder(string, defaultDecoder, charset);
    }
};

const stringify = (data: any, options?: IStringifyOptions) =>
    qs.stringify(data, options);

const parse = <T extends QueryStringKeyValue = DefaultQueryStringKeyValue>(string: string = window.location.search, options: IParseOptions = defaultParseOptions) =>
    qs.parse(string, options) as Partial<T>;

const getFromParsed = <T extends QueryStringValue = DefaultQueryStringValue>(name: string, parsed: any) => {
    for (const key of name.split('.')) {
        parsed = parsed[key];

        if (parsed === undefined)
            return null;
    }

    return parsed as T;
};

const get = <T extends QueryStringValue = DefaultQueryStringValue>(name: string, options: IParseOptions = defaultParseOptions) => getFromParsed<T>(name, parse(window.location.search, options));

function getAll<K extends string = string>(names: readonly K[] | K[], options?: IParseOptions): { [key in K]: DefaultQueryStringValue };
function getAll<T extends { [key in K]: QueryStringValue }, K extends string = string>(names: readonly K[] | K[], options?: IParseOptions): T;
function getAll(names: readonly string[] | string[], options: IParseOptions = defaultParseOptions) {
    let parsed: any = parse(window.location.search, options);

    return (names as string[]).reduce((result, name) => ({ ...result, [name]: getFromParsed(name, parsed) }), {});
}

const queryString = { stringify, parse, get, getAll };

export default queryString;
